// extracted by mini-css-extract-plugin
module.exports = {"starRating":"StarRating_starRating__J28Rb"};